'use strict';

angular.module('ringbaPortal.services')
  .factory('authInterceptorService', function($rootScope, $log, $q, $injector, localStorageService) {

    const MfaRequiredSubstatus = 2;

    const authInterceptorServiceFactory = {};
    let refreshInFlight = false;
    let $http = null;
    const requestQueue = [];
    const responseQueue = [];
    $rootScope.$on('tokenRefresh', function() {
      let rejection = responseQueue.shift(), defer;
      while (rejection) {
        defer = responseQueue.shift();
        if (!$http) {
          $http = $injector.get('$http');
        }
        defer.resolve($http(rejection.config));
        rejection = responseQueue.shift();
      }
    });

    const _request = function(config) {
      let defer;
      const ngAuthSettings = $injector.get('ngAuthSettings');
      let handler;

      config.headers = config.headers || {};
      let authData = localStorageService.get('authService.authorizationData');
      authData = authData && authData.value;
      if (authData) {
        config.headers.Authorization = 'Bearer ' + authData.token;
      }

      if (!refreshInFlight || (ngAuthSettings.apiServiceBaseUri + 'token' === config.url)) {
        return config;
      } else {
        defer = $q.defer();
        requestQueue.push(config);
        requestQueue.push(defer);
        handler = $rootScope.$on('tokenRefresh', function() {
          let tempDefer;
          handler();
          while (config === requestQueue.shift()) {
            tempDefer = requestQueue.shift();
            tempDefer.resolve(config);
          }
        });
        return defer.promise;
      }
    };

    const _responseError = function (rejection) {
      const defer = $q.defer();
      const authService = $injector.get('authService');
      let authData;
      if (rejection.status === 401) {
        const $state = $injector.get('$state');
        const $timeout = $injector.get('$timeout');
        authData = localStorageService.get('authService.authorizationData');
        authData = authData && authData.value;
        $log.getInstance('authService').error('401 auth error', rejection, authData);

        if (!refreshInFlight) {
          if (authData) {
            if (authData.useRefreshTokens) {
              refreshInFlight = true;
              authService.refreshToken().then(function() {
                refreshInFlight = false;
                $rootScope.$broadcast('tokenRefresh');

                // This retries the original request
                if (!$http) {
                  $http = $injector.get('$http');
                }
                defer.resolve($http(rejection.config));
              },
              function(error) {
                $log.getInstance('authService').warn('Couldn\'t refresh token', error, $rootScope.pageTransition);
                refreshInFlight = false;
                $rootScope.$broadcast('tokenRefresh');
                if (!$rootScope.pageTransition) {
                  $timeout(function() {
                    $state.go('login');
                  });
                }
                defer.reject(rejection);
              });
            }
          } else {
            authService.logOut();
            defer.reject(rejection);
          }
        } else {
          responseQueue.push(rejection);
          responseQueue.push(defer);
        }
      } else if (rejection.status === 403 && rejection.data?.substatus === MfaRequiredSubstatus) {
        $log.getInstance('authService').error('403 MFA Required', rejection, authData);
        authService.logOut();
      } else {
        defer.reject(rejection);
      }
      return defer.promise;
    };

    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.responseError = _responseError;

    return authInterceptorServiceFactory;
  })
;
